import React from 'react';
import type { ImageInitialModel } from '@src/utils/formatImage';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { showPic } from '@src/mobile/components/pics/utils';

type PicProps = {
    content: {
        images: ImageInitialModel[];
    };
};

const PicFourMore: React.FC<PicProps> = ({ content }) => {
    const { images } = content;

    return (
        <div className={styles.wrap}>
            <div className={styles.col}>
                <div className={styles.colSizer} />
                <div className={styles.colContent}>
                    <div className={styles.row}>
                        <div className={styles.rowSizer} />
                        <div
                            className={styles.thumbnailWrap}
                            onClick={() => {
                                showPic({ images, index: 0 });
                            }}
                        >
                            <img src={images[0].url} alt="" className={styles.thumbnail} />
                        </div>
                    </div>
                    <div className={styles.row}>
                        <div className={styles.rowSizer} />
                        <div
                            className={styles.thumbnailWrap}
                            onClick={() => {
                                showPic({ images, index: 2 });
                            }}
                        >
                            <img src={images[2].url} alt="" className={styles.thumbnail} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.col}>
                <div className={styles.colSizer} />
                <div className={styles.colContent}>
                    <div className={styles.row}>
                        <div className={styles.rowSizer} />
                        <div
                            className={styles.thumbnailWrap}
                            onClick={() => {
                                showPic({ images, index: 1 });
                            }}
                        >
                            <img src={images[1].url} alt="" className={styles.thumbnail} />
                        </div>
                    </div>
                    <div className={styles.row}>
                        <div className={styles.rowSizer} />
                        <div
                            className={styles.thumbnailWrap}
                            onClick={() => {
                                showPic({ images, index: 3 });
                            }}
                        >
                            <img src={images[3].url} alt="" className={styles.thumbnail} />
                            {images.length - 4 > 0 ? (
                                <div className={styles.more}>
                                    <div className={styles.moreText}>+{images.length - 4}</div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default errorBoundary(PicFourMore);
